"use client";
import "../../../chunk-MMUBH76A.js";
const createModalSlice = (set) => ({
  isOpen: false,
  setIsOpen: (isOpen) => set({ isOpen })
});
export {
  createModalSlice
};
